module.exports = __webpack_public_path__ + "media/unipod/icon-completion-black-45925ba9.svg";